import React from 'react';
import { FC } from 'react';

interface LogoProps {
  [key: string]: any;
}

const Logo: FC<LogoProps> = props => {
  return (
    <img
      alt="Logo"
      style={{ height: 40 }}
      src="/static/logo-white.png"
      {...props}
    />
  );
};

export default Logo;
